import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';
import {ProjectReferenceListComponent} from './pages/project-reference-list/project-reference-list.component';
import {environment} from '../environments/environment';
import {ProjectReferenceDetailComponent} from './pages/project-reference-detail/project-reference-detail.component';
import {LoginPageComponent} from './pages/login-page/login-page.component';

const routes: Routes = [
    {
        path: 'login',
        component: LoginPageComponent
    },
    {
        path: '',
        canActivate: environment.useMock ? [] : [MsalGuard],
        children: [
            {
                path: 'project-references',
                children: [
                    {
                        path: '',
                        component: ProjectReferenceListComponent
                    },
                    {
                        path: ':id',
                        component: ProjectReferenceDetailComponent
                    }
                ]
            },
            {
                path: '**',
                redirectTo: 'project-references'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
